import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumVesselMaintenancePeriodBasis implements BaseEnumType {
  private static allValues: EnumVesselMaintenancePeriodBasis[] = []; // make sure this is top-most
  
  public static uses = new EnumVesselMaintenancePeriodBasis(0, "Uses", "enum_vessel_maintenance_period_basis_uses");
  public static days = new EnumVesselMaintenancePeriodBasis(1, "Days", "enum_vessel_maintenance_period_basis_days");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumVesselMaintenancePeriodBasis.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isUses() { return this === EnumVesselMaintenancePeriodBasis.uses; }
  public isDays() { return this === EnumVesselMaintenancePeriodBasis.days; }

  public static getValues(): readonly EnumVesselMaintenancePeriodBasis[] {
    return EnumVesselMaintenancePeriodBasis.allValues;
  }

  public static getValuesExcept0(): readonly EnumVesselMaintenancePeriodBasis[] {
    return EnumVesselMaintenancePeriodBasis.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumVesselMaintenancePeriodBasis {
    const found = EnumVesselMaintenancePeriodBasis.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumVesselMaintenancePeriodBasis - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumVesselMaintenancePeriodBasis): EnumVesselMaintenancePeriodBasis {
    const found = name ? EnumVesselMaintenancePeriodBasis.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumVesselMaintenancePeriodBasis - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumVesselMaintenancePeriodBasis>): boolean {
    return this.key === other?.key;
  }
}